<template>
  <div class="panel-group-container">
    <div v-if="setbrandid === 'LAX'" class="lax-comp">
      <div class="lax-heading">Reasons to park with us</div>

      <div class="panel-group-lax">
        <div class="panel-lax">
          <img src="https://res.cloudinary.com/rezcomm2018/image/upload/v1737623342/brands/LAX/LAX_Flexible_Icon.png" alt="Flexibility">
          <div class="panel-lax-content">
            <p class="panel-lax-title">Flexibility</p>
            <p class="panel-lax-description">We allow you to change your reservation up to 2 hours before you fly.</p>
          </div>
        </div>
        <div class="panel-lax">
          <img src="https://res.cloudinary.com/rezcomm2018/image/upload/v1737623324/brands/LAX/LAX_No_Reservation_Fees_Icon.png" alt="No Reservation Fees">
          <div class="panel-lax-content">
            <p class="panel-lax-title">No Reservation Fees</p>
            <p class="panel-lax-description">The price you see is the price you'll pay. Taxes are included in the price you see.</p>
          </div>
        </div>
        <div class="panel-lax">
          <img src="https://res.cloudinary.com/rezcomm2018/image/upload/v1737623341/brands/LAX/LAX_Same_Day_Bookings_Icon.png" alt="Same Day Bookings">
          <div class="panel-lax-content">
            <p class="panel-lax-title">Same Day Bookings</p>
            <p class="panel-lax-description">We've got you covered for those last-minute trips.</p>
          </div>
        </div>
        <div class="panel-lax">
          <img src="https://res.cloudinary.com/rezcomm2018/image/upload/v1737623341/brands/LAX/LAX_Convenient_Icon.png" alt="Convenient">
          <div class="panel-lax-content">
            <p class="panel-lax-title">Convenient</p>
            <p class="panel-lax-description">You can't park any closer to the terminal..</p>
          </div>
        </div>
      </div>
    </div>

    <div v-if="setbrandid === 'SV1'" class="panel-group">
      <div class="panel-row panel-row-3">
        <div class="panel-inner">
          <div class="panel image-right" style="width: 100%;">
            <div class="panel-data">
              <h3>Get more from your journey</h3>
              <p style="width: 100%;">
                • A personalized parking solution near the Halifax Stanfield International Airport<br/>
                • Includes a free 4-minute shuttle to the terminal door <br/>
                • Secure, affordable parking with 24/7 support
              </p>
              <a target="_blank" rel="noopener noreferrer" class="panel-data__button" href="https://www.summitairportparking.com/" data-v-d32d57f8="">Learn more</a>
            </div>
            <div class="panel-image" data-v-d32d57f8=""></div></div>
            <div class="panel no-image" data-v-d32d57f8="" data-v-093122d0="">
              <div class="panel-data" data-v-d32d57f8="">
                <h3 data-v-d32d57f8=""></h3>
                <p data-v-d32d57f8=""></p>
              </div>
              <div class="panel-image" data-v-d32d57f8="">
                <img src="https://res.cloudinary.com/rezcomm2018/image/upload/f_auto,q_auto/v1713282019/brands/SV1/panels/1713282019_Map Rez.png/a28nzdwouz8clhmtkuqx.png" data-v-d32d57f8="">
              </div>
            </div>
          </div>
        </div>
    </div>

    <div v-if="setbrandid === 'LDY'" class="panel-group">
      <div class="panel-row panel-row-3">
        <div class="panel-inner">
          <div class="panel image-right">
            <div class="panel-data">
              <h3>Secure parking</h3>
              <p>
                <span>
                The car park will be locked and secured during periods when the airport is closed.
                Airport opening times (please note, these times are subject to change):</span>
                <table>
                    <tbody><tr>
                        <td>
                        Monday - Friday
                        </td>
                        <td>
                        <b>&nbsp;&nbsp;&nbsp;05:00 - 22:15</b>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        Saturday
                        </td>
                        <td>
                        <b>&nbsp;&nbsp;&nbsp;05:00 - 18:00</b>
                        </td>
                    </tr>
                    <tr>
                        <td>
                        Sunday
                        </td>
                        <td>
                        <b>&nbsp;&nbsp;&nbsp;07:00 - 22:15</b>
                        </td>
                    </tr>
                </tbody></table>
                <br>
                <span>Christmas Day <b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Closed</b></span>
                <br>
                <span>New Year's Day <b>&nbsp;&nbsp;&nbsp;05:00 - 09:00</b> </span>
                <br>
                <br>
                <span style="margin-top: 15px;">If you require out of hours access to retrieve your vehicle (see airport opening times),
                please contact the Airport Customer Services on: <a class="BF-marketing-link" target="_blank" href="tel:028 7181 3302">028 7181 3302</a> during normal operating hours,
                in advance where possible, and we will plan to accommodate your request.</span>
            </p>
            <br><br>
            <br><br>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="setbrandid === 'DRW'" class="drw-panel-group">
      <div class="drw-boxes-container">
        <div class="feature-box contactless">
          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751447417/brands/DRW/86e69158034e7bdb0eb791cac18a7a438677a8dc.svg"
            class="feature-icon"
          />
          <div class="feature-text">
            <div class="feature-title">Contactless</div>
            <div class="feature-description">
              Uses license plate recognition, so there is no need to take a ticket
              or make payment at a pay station.
            </div>
          </div>
        </div>
        <div class="feature-box value">
          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751447416/brands/DRW/a79bdfd136fc0f552798660ef514b04960ed51e5.svg"
            class="feature-icon"
          />
          <div class="feature-text">
            <div class="feature-title">
              Book online for our <br />best rates
            </div>
            <div class="feature-description">
              Pre-book online and obtain great discounts compared to our drive-up
              rates.
            </div>
          </div>
        </div>
        <div class="feature-box convenient">
          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751447416/brands/DRW/4d2fb8a2e53ba999cb2b6217c0082a0dc582e958.svg"
            class="feature-icon"
          />
          <div class="feature-text">
            <div class="feature-title">Convenient</div>
            <div class="feature-description">
              Conveniently located car parks offering a choice of parks that suit
              all budgets.
            </div>
          </div>
        </div>
        <div class="feature-box park-n-go">
          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751447416/brands/DRW/17f42820609e0bbec6dc9bf56adba1ed22a1dabd.svg"
            class="feature-icon"
          />
          <div class="feature-text">
            <div class="feature-title">Park 'n' Go</div>
            <div class="feature-description">
              Park just steps from the terminal and travel.
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="setbrandid === 'ASP'" class="drw-panel-group">
      <div class="drw-boxes-container">
        <div class="feature-box contactless">
          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751885153/brands/ASP/ASP_Car.svg"
            class="feature-icon"
          />
          <div class="feature-text">
            <div class="feature-title">Contactless</div>
            <div class="feature-description">
              Uses license plate recognition, so there is no need to take a ticket
              or make payment at a pay station.
            </div>
          </div>
        </div>
        <div class="feature-box value">
          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751885154/brands/ASP/ASP_Best_Rates.svg"
            class="feature-icon"
          />

          <div class="feature-text">
            <div class="feature-title">
              Book online for our <br />best rates
            </div>
            <div class="feature-description">
              Pre-book online and obtain great discounts compared to our drive-up
              rates.
            </div>
          </div>
        </div>
        <div class="feature-box convenient">
          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751885153/brands/ASP/ASP_Convenient.svg"
            class="feature-icon"
          />
          <div class="feature-text">
            <div class="feature-title">Convenient</div>
            <div class="feature-description">
              Conveniently located car parks offering a choice of parks that suit
              all budgets.
            </div>
          </div>
        </div>
        <div class="feature-box park-n-go">

          <img
            src="https://res.cloudinary.com/rezcomm2018/image/upload/v1751885153/brands/ASP/ASP_Park_n_Go.svg"
            class="feature-icon"
          />
          <div class="feature-text">
            <div class="feature-title">Park 'n' Go</div>
            <div class="feature-description">
              Park just steps from the terminal and travel.
            </div>
          </div>
        </div>
      </div>
    </div>

   <!--  <div class="announcement-banner" v-if="setbrandid === 'PIT'">
      Please be advised that Parking Lot 1 is currently closed, or a snowstorm has caused a blockage on certain roads within the site. We apologize for any inconvenience this may cause.
    </div> -->
    <!-- <div v-if="setbrandid === 'PIT'" class="panel-group-pit">
        <img width="560" height="auto" style="width: 100%; height: auto" src="https://res.cloudinary.com/rezcomm2018/image/upload/v1729775861/brands/PIT/REZ_Home_Page_Products-Map.jpg"/>
    </div> -->

    <div class="panel-group"  v-if="setbrandid !== 'SV1' && setbrandid !== 'ASP' && setbrandid !== 'LDY' && setbrandid !== 'PIT' && setbrandid !== 'NQY' && setbrandid !== 'DRW'">
      <div
        v-for="(panel_row, i) in panels_group"
        :key="panel_row.row"
        :class="`panel-row panel-row-${i}`"
      >
        <div class="panel-inner">
          <template v-for="panel in panel_row.columns" :key="panel.panelid">
            <Panel
              :panel_data="panel"
              :lang="lang.toUpperCase()"
              :translations="translations"
              :brandSlug="setbrandid"
            />
          </template>
        </div>
      </div>
    </div>

    <div v-if="setbrandid === 'NQY'" class='panel-group-nqy'>
      <img
        style="width: 100%; height: auto;"
        class="waves"
        src="https://res.cloudinary.com/rezcomm2018/image/upload/v1743686877/brands/NQY/illustration.png"
        alt="Waves"
      />
    </div>



  </div>






    <div v-if="setbrandid === 'CP1'">

<div class="ID-columns-wrapper cosmo">
	<div class="ID-columns">


      <div class="cosmo-tiles-wrapper">

          <div class="ID-column-row ID-column-row-1">
              <div class="ID-column-row-inner">
                  <div class="ID-column-item" style="width: 100%; margin: 0px !important; position: relative;">
                      <div class="ID-column-text-outsideTheBox">
                            <div class="ID-column-image-inner cosmo-svg-homepage cosmo-svg-homepage-small cp1-feature-circle"
                              style="background-image: url('https://res.cloudinary.com/rezcomm2018/image/upload/v1777451736/brands/CP1/CP1_homepage_images/question-mark.svg')">
                            </div>
                          <h1>Cosmo Airport Car Parking is the most convenient parking at Belfast International. We are the closest off-airport car park to the airport – just a 1 minute transfer.</h1>
                          <!-- underline removed -->
                      </div>
                  </div>
              </div>
          </div>

          <div class="ID-column-row ID-column-row-3">
            <div class="ID-column-row-inner cosmo-icons-wide">
              <div class="ID-column-item" style="margin: 0px !important; position: relative;">
                <div class="ID-column-text-outsideTheBox">
                  <div class="ID-column-image-inner cosmo-svg-homepage cp1-feature-circle" style="background-image: url('https://res.cloudinary.com/rezcomm2018/image/upload/v1777451736/brands/CP1/CP1_homepage_images/pound-symbol-variant.svg')"></div>
                  <div class="ID-column-text" style="display: block; padding: 0px; width: 100%; margin: 0 auto; text-align: center;min-height: 0px;">
                    <h2 style="padding: 0 30px">Convenient parking at affordable prices</h2>
                  </div>
                </div>
              </div>
              <div class="ID-column-item" style="margin: 0px !important">
                <div class="ID-column-text-outsideTheBox">
                  <div class="ID-column-image-inner cosmo-svg-homepage cp1-feature-circle" style="background-image: url('https://res.cloudinary.com/rezcomm2018/image/upload/v1777451737/brands/CP1/CP1_homepage_images/phone.svg')"></div>
                  <div class="ID-column-text" style="display: block; padding: 0px; width: 100%; margin: 0 auto; text-align: center;min-height: 0px;">
                    <h2 style="padding: 0 30px">Touch free entry and exit</h2>
                  </div>
                </div>
              </div>
              <div class="ID-column-item" style="margin: 0px !important">
                <div class="ID-column-text-outsideTheBox">
                  <div class="ID-column-image-inner cosmo-svg-homepage cp1-feature-circle" style="background-image: url('https://res.cloudinary.com/rezcomm2018/image/upload/v1777451736/brands/CP1/CP1_homepage_images/hourglass.svg')"></div>
                  <div class="ID-column-text" style="display: block; padding: 0px; width: 100%; margin: 0 auto; text-align: center;min-height: 0px;">
                    <h2 style="padding: 0 30px">Only 1 minute from the terminal</h2>
                  </div>
                </div>
              </div>
              <div class="ID-column-item" style="margin: 0px !important">
                <div class="ID-column-text-outsideTheBox">
                  <div class="ID-column-image-inner cosmo-svg-homepage cp1-feature-circle" style="background-image: url('https://res.cloudinary.com/rezcomm2018/image/upload/v1777451736/brands/CP1/CP1_homepage_images/bus.svg')"></div>
                  <div class="ID-column-text" style="display: block; padding: 0px; width: 100%; margin: 0 auto; text-align: center;min-height: 0px;">
                    <h2 style="padding: 0 30px">Free shuttle bus</h2>
                  </div>
                </div>
              </div>
              <div class="ID-column-item" style="margin: 0px !important">
                <div class="ID-column-text-outsideTheBox">
                  <div class="ID-column-image-inner cosmo-svg-homepage cp1-feature-circle" style="background-image: url('https://res.cloudinary.com/rezcomm2018/image/upload/v1777451736/brands/CP1/CP1_homepage_images/cctv.svg')"></div>
                  <div class="ID-column-text" style="display: block; padding: 0px; width: 100%; margin: 0 auto; text-align: center;min-height: 0px;">
                    <h2 style="padding: 0 30px">Safe & Secure 365/24/7 CCTV Coverage</h2>
                  </div>
                </div>
              </div>
              <div class="ID-column-item" style="margin: 0px !important">
                <div class="ID-column-text-outsideTheBox">
                  <div class="ID-column-image-inner cosmo-svg-homepage cp1-feature-circle" style="background-image: url('https://res.cloudinary.com/rezcomm2018/image/upload/v1777451736/brands/CP1/CP1_homepage_images/checked.svg')"></div>
                  <div class="ID-column-text" style="display: block; padding: 0px; width: 100%; margin: 0 auto; text-align: center;min-height: 0px;">
                    <h2 style="padding: 0 30px">Park Mark Accredited</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="cosmo-map-row-fullwidth">
            <iframe
              width="100%"
              height="340"
              frameborder="0" style="border:0; display: block;"
              allowfullscreen
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCtBiiXdmZaHER1ys6oNb226-Heurqe12A&q=place_id:ChIJXbnezNaqYUgRqmyzcKim8J8">
            </iframe>
          </div>

          </div>
      </div>

    

    </div>
  </div>

</template>

<script>
import Panel from "./Panel.vue";
export default {
  components: {
    Panel,
  },
  name: "PanelsGroup",
  props: {
    panels_group: undefined,
    lang: undefined,
    translations: undefined,
    setbrandid: undefined,
  },
};
</script>

<style scoped lang="scss">
.waves {
  position: relative;
  bottom: 0;
  left: 0;
}

.lax-comp {
  background-color: #f4f4f4;
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.lax-heading {
  font-weight: bold;
  text-align: center;
  font-size: 28px;
}

.panel-group-lax {
  display: flex;
  max-width: 1300px;
  margin: auto;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
}

@media screen and (min-width: 768px) {
  .panel-group-lax {
    padding: 4rem;
  }
  .panel-lax {
    flex: 1 0 48%;
  }
}

@media screen and (min-width: 1024px) {
  .panel-group-lax {
    padding: 1rem;
  }
  .panel-lax {
    flex: 1 0 22%;
  }
}

.panel-lax {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.panel-lax img {
  padding: 10px;
  width: 100px;
  height: 100px;
  margin: 0 auto;
}

.panel-lax-content {
  display: flex;
  margin-top: 10px;
  text-align: left;
  flex-direction: column;
  .panel-lax-title {
    font-weight: 700;
    color: #00a9ce;
    font-size: medium;
  }
  .panel-lax-description {
    font-size: small;
    max-width: 100%;
  }
}

// DRW Panel Group Styles
.drw-panel-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: Fira Sans, -apple-system, Roboto, Helvetica, sans-serif;
  color: rgba(0, 61, 77, 1);
  text-align: center;
  justify-content: center;
  padding: 0;
  margin: 6rem auto;

  @media (max-width: 991px) {
    padding: 0 20px;
  }
}

.drw-boxes-container {
  display: flex;
  align-items: center;
  gap: 25px;
  justify-content: center;
  flex-wrap: wrap;

  @media (max-width: 991px) {
    max-width: 100%;
  }
}

.feature-box {
  align-items: center;
  border-radius: 8px;
  box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.25);
  align-self: stretch;
  display: flex;
  min-width: 240px;
  min-height: 284px;
  flex-direction: column;
  justify-content: flex-start;
  width: 294px;
  background-color: var(--WHITE, #fff);
  margin: auto 0;

  &.contactless {
    padding: 22px 16px 51px;
  }

  &.value {
    padding: 23px 16px;
  }

  &.convenient {
    padding: 22px 16px 47px;
  }

  &.park-n-go {
    padding: 22px 16px 69px;
  }
}

.feature-icon {
  object-fit: contain;
  object-position: center;
}

.contactless .feature-icon {
  aspect-ratio: 1.07;
  width: 73px;
}

.value .feature-icon {
  aspect-ratio: 1;
  width: 74px;
}

.convenient .feature-icon {
  aspect-ratio: 0.87;
  width: 63px;
}

.park-n-go .feature-icon {
  aspect-ratio: 0.93;
  width: 69px;
}

.feature-text {
  margin-top: 24px;
  max-width: 100%;
  width: 262px;
}

.feature-title {
  font-size: 24px;
  font-weight: 700;

  &:has(br) {
    line-height: 29px;
  }
}

.feature-description {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-top: 11px;
}

.panel-group-container {
  background-color: var(--panel-background-color);

  @media screen and (min-width: 768px) {
    margin-top: 3rem;
    padding: 3rem 0;
  }

  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
    padding: 1rem 0;
  }

  .panel {
    &-group {
      position: relative;
      margin: 0 auto;
    }

    &-row {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 1rem;
      justify-content: center;
      padding: 0 1rem;
    }
  }

  .panel-group {
    gap: 1rem;
    display: flex;
    flex-direction: column;
    min-height: 320px;
  }

  .panel-inner {
    margin: 0 auto;
    max-width: 1280px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 1rem;
    justify-content: center;
    width: 100%;

    @media screen and (max-width: 566.99px) {
      align-items: center;
      flex-wrap: wrap;
    }

    @media screen and (min-width: 567px) {
      flex-direction: row;
      flex-wrap: wrap;
    }

    @media screen and (min-width: 960px) {
      flex-direction: row;
      flex-wrap: nowrap;
    }
  }
}
</style>

<style lang="scss">
// NWI Brand mods
.NWI {
  .panel-group-container {
    padding: 0;
    background: rgb(245, 245, 245);
    .panel-row-1 {
      padding: 3rem 0;
      @media screen and (max-width: 1320px) {
        padding: 3rem 1rem;
      }
      .panel.image-left {
        justify-content: flex-end;
      }
      .panel-image img {
        max-height: 220px;
      }
      .panel.image-right {
        max-width: 100%;
      }
    }
  }
}

// IP1 Brand mods
.IP1 {
  .panel-group-container {
    padding: 0;
    background: #fff;
    .panel-row-1 {
      background: rgb(245, 245, 245);
      padding: 3rem;
      .panel.image-left {
        justify-content: flex-end;
      }
      .panel-image img {
        max-height: 220px;
      }
    }
    .panel-row-2,
    .panel-row-3 {
      text-align: center;
      .panel.image-top {
        box-shadow: 0px 0px 0px #00000000;
      }
      .panel-image img {
        width: auto;
        max-height: 150px;
      }
      .panel-data {
        padding: 1rem;
      }
    }
    .panel-row-2 {
      padding-top: 3rem;
    }
    .panel-row-3 {
      padding-bottom: 3rem;
    }
  }
}

.PIT {
  .panel-group-container {
    padding: 0;
    background: #fff;
  }
}

.panel-group-pit {
  margin: 0 auto;
  margin-top: 1rem;
  max-width: 1320px;
  width: 100%;
  margin-bottom: 5rem;
  @media screen and (max-width: 786) {
    margin-top: 5rem;
  }
  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
    padding: 1rem 0;
    max-width: calc(100% - 2rem);
    margin-top: 10px;
  }
}
.panel-group-nqy {
  margin: 0 auto;
  width: 100%;
  background-color: #fff;
  @media screen and (max-width: 786) {
    margin-top: 5rem;
  }
}

.announcement-banner {
  width: 100%;
  margin-top: -25px;
  background-color: #f5c6cb;
  color: #721c24;
  text-align: center;
  padding: 10px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 1260px) {
    margin-top: 10px;
  }
}

// add cosmo styles here

.ID-columns-wrapper.cosmo {
  background: #004481;
  background: linear-gradient(#003d79 0%, #002b55 100%);
  padding: 2.5rem 0 0 0;
  color: #fff;
  width: 100%;
  .ID-columns {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 1rem;
  }
  .cosmo-tiles-wrapper {
    width: 100%;
  }
  .ID-column-row-1 {
    .ID-column-text-outsideTheBox {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      margin-bottom: 2.5rem;
      h1 {
        font-size: 1.75rem;
        font-weight: 700;
        margin: 1.2rem 0 0.2rem 0;
        color: #fff;
        line-height: 1.25;
        text-align: center;
        letter-spacing: 0.01em;
        max-width: 1200px;
      }
      // .cosmo-header-underline removed
      .cosmo-svg-homepage-small {
        width: 60px;
        height: 60px;
        margin: 0 auto;
        background-repeat: no-repeat;
        filter: brightness(0) saturate(100%) invert(87%) sepia(97%)
          saturate(749%) hue-rotate(12deg);
      }
    }
  }
  .ID-column-row-3 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .cosmo-icons-wide {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-template-rows: repeat(2, 1fr);
      gap: 2.5rem 2.5rem;
      justify-items: center;
      align-items: start;
      margin: 2.5rem 0 0 0;
      width: 100%;
      max-width: 1200px;
    }
    .ID-column-item {
      background: transparent;
      box-shadow: none;
      border: none;
      min-width: 160px;
      max-width: 320px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      text-align: center;
      .ID-column-text-outsideTheBox {
        display: flex;
        flex-direction: column;
        align-items: center;
        .cosmo-svg-homepage {
          width: 70px;
          height: 70px;
          margin: 0 auto 1.2rem auto;
          background-repeat: no-repeat;
          filter: brightness(0) saturate(100%) invert(87%) sepia(97%)
            saturate(749%) hue-rotate(12deg);
        }
        .ID-column-text {
          h2 {
            color: #fff;
            font-size: 1.15rem;
            font-weight: 700;
            margin: 0.5rem 0 0 0;
            line-height: 1.3;
            text-align: center;
          }
        }
      }
    }
  }
  .cosmo-map-row-fullwidth {
    width: 100vw;
    margin-left: 50%;
    transform: translateX(-50%);
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin-top: 2.5rem;
    margin-bottom: 0;
  }
  .cosmo-map-row-fullwidth iframe {
    width: 100vw;
    min-height: 340px;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);
    border: none;
    display: block;
  }
  @media (max-width: 1200px) {
    .ID-column-row-3 .cosmo-icons-wide {
      max-width: 1000px;
    }
  }
  @media (max-width: 900px) {
    .ID-column-row-3 .cosmo-icons-wide {
      grid-template-columns: repeat(2, 1fr);
      gap: 1.2rem;
      max-width: 700px;
    }
    .ID-column-row-3 .ID-column-item {
      min-width: 120px;
      max-width: 100%;
    }
    .ID-column-row-1 .ID-column-text-outsideTheBox h1 {
      font-size: 1.3rem;
    }
    .cosmo-map-row-fullwidth iframe {
      min-height: 220px;
    }
  }
  @media (max-width: 600px) {
    .ID-column-row-3 .cosmo-icons-wide {
      grid-template-columns: 1fr;
      max-width: 100%;
    }
    .cosmo-map-row-fullwidth iframe {
      min-height: 160px;
    }
  }
}

/* CP1 Feature Icon Circles */
.cp1-feature-circle {
  border: 2px solid #e3e94e;
  border-radius: 50%;
  width: 130px;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  box-sizing: border-box;
  background-size: 50%;
  background-repeat: no-repeat;
  background-position: center;
}

@import "@/assets/sass/override_brand.scss";
</style>